var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import CustomFieldText from './custom-field-text';
import CustomFieldNumber from './custom-field-number';
import CustomFieldLongText from './custom-field-longtext';
import CustomFieldDropdown from './custom-field-dropdown';
import CustomFieldRadio from './custom-field-radio';
import CustomFieldCheckbox from './custom-field-checkbox';
import CustomFieldEditor from './custom-field-editor';
import { CustomFieldType } from './models';
import { FormControl, Grid, MenuItem, Select } from '@material-ui/core';
import { inject, observer } from 'mobx-react';
import CustomFieldLineBreak from './custom-field-linebreak';
import { Button, Stack } from '@mui/material';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import VisibilityIcon from '@mui/icons-material/Visibility';
import ListIcon from '@mui/icons-material/List';
import RotateLeftIcon from '@mui/icons-material/RotateLeft';
import { buildAddressString } from '../address-book/models';
import { NO_ID } from '../common/ids';
var CustomFieldsPanel = /** @class */ (function (_super) {
    __extends(CustomFieldsPanel, _super);
    function CustomFieldsPanel(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            isPreviewMode: false
        };
        return _this;
    }
    Object.defineProperty(CustomFieldsPanel.prototype, "render", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var formClassName = this.props.isEditMode ? 'custom-fields-panel-editor-mode' : '';
            return (_jsxs("div", __assign({ className: "custom-fields-panel case-types-tab-panel" }, { children: [_jsxs(Stack, __assign({ spacing: 2, direction: "row" }, { children: [this.renderAddButton(), this.renderPreviewButton(), this.renderResetButton(), _jsxs(Grid, __assign({ container: true, direction: "row", alignItems: "center" }, { children: [this.renderCaseTypeSelect(), this.renderAddressSelect()] }), void 0)] }), void 0), _jsx("form", __assign({ className: formClassName, noValidate: true, autoComplete: "off" }, { children: _jsx(Grid, __assign({ item: true, container: true, direction: this.props.isEditMode && !this.state.isPreviewMode ? 'column' : 'row', alignItems: "stretch", justifyContent: "flex-start" }, { children: this.renderFields() }), void 0) }), void 0)] }), void 0));
        }
    });
    Object.defineProperty(CustomFieldsPanel.prototype, "renderFields", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a;
            return (_a = this.props.fieldsStore) === null || _a === void 0 ? void 0 : _a.fields.map(function (field, index) {
                var _a;
                var control = null;
                var label = (_a = _this.props.languageStore) === null || _a === void 0 ? void 0 : _a.getLabelForField(field);
                var width = field.width;
                var style = { padding: '10px 0 10px 0' };
                switch (field.type) {
                    case CustomFieldType.Text:
                        var maxLength = field.name === 'Field.ExternalID' ? 100 : undefined;
                        control = _jsx(CustomFieldText, { field: field, label: label, maxLength: maxLength }, void 0);
                        break;
                    case CustomFieldType.LongText:
                        control = _jsx(CustomFieldLongText, { field: field, label: label }, void 0);
                        break;
                    case CustomFieldType.Number:
                        control = _jsx(CustomFieldNumber, { field: field, label: label }, void 0);
                        break;
                    case CustomFieldType.List:
                        control = _jsx(CustomFieldDropdown, { field: field, label: label }, void 0);
                        break;
                    case CustomFieldType.Radio:
                        control = _jsx(CustomFieldRadio, { field: field, label: label }, void 0);
                        break;
                    case CustomFieldType.Checkbox:
                        control = _jsx(CustomFieldCheckbox, { field: field, label: label }, void 0);
                        break;
                    case CustomFieldType.LineBreak:
                        control = _jsx(CustomFieldLineBreak, { field: field, isEditMode: _this.props.isEditMode && !_this.state.isPreviewMode }, void 0);
                        width = 12;
                        style = { 'padding': '0' };
                        break;
                    default:
                        control = _jsx("div", { children: "Unsupported field type" }, void 0);
                        break;
                }
                var gridSize = _this.props.isEditMode && !_this.state.isPreviewMode ? 12 : width;
                var controlSize = _this.props.isEditMode && !_this.state.isPreviewMode ? 3 : 12;
                return (_jsxs(Grid, __assign({ item: true, container: true, xs: gridSize, style: style }, { children: [_jsx(Grid, __assign({ item: true, container: true, xs: controlSize, style: { padding: '0 20px 0 0' } }, { children: control }), void 0), _this.renderEditor(field)] }), index));
            });
        }
    });
    Object.defineProperty(CustomFieldsPanel.prototype, "renderEditor", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (field) {
            if (!this.props.isEditMode || this.state.isPreviewMode)
                return (null);
            return (_jsx(Grid, __assign({ item: true, xs: 9 }, { children: _jsx(CustomFieldEditor, { field: field }, void 0) }), void 0));
        }
    });
    Object.defineProperty(CustomFieldsPanel.prototype, "renderCaseTypeSelect", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a, _b, _c, _d;
            if (this.props.isEditMode || this.state.isPreviewMode)
                return (null);
            var items = (_b = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.caseTypes) === null || _b === void 0 ? void 0 : _b.map(function (t, index) { return (_jsx(MenuItem, __assign({ value: t.id }, { children: t.name }), index)); });
            var label = (_c = this.props.languageStore) === null || _c === void 0 ? void 0 : _c.getLabel('Claims.CaseType');
            var currentCaseTypeId = (_d = this.props.caseTypesStore) === null || _d === void 0 ? void 0 : _d.currentCaseTypeId;
            if (!currentCaseTypeId)
                currentCaseTypeId = '';
            return (_jsxs(Grid, __assign({ container: true, alignItems: "center", item: true, sm: 3 }, { children: [_jsx("label", { children: _jsx("b", { children: label }, void 0) }, void 0), _jsx(FormControl, __assign({ disabled: this.props.isCaseTypeSelectorHidden, style: { flex: 1, marginLeft: '15px', paddingRight: '20px' }, variant: "outlined" }, { children: _jsx(Select, __assign({ name: "caseTypeSelect", value: currentCaseTypeId, onChange: function (e) { return _this.onCaseTypeValueChanged(e); } }, { children: items }), void 0) }), void 0)] }), void 0));
        }
    });
    Object.defineProperty(CustomFieldsPanel.prototype, "renderAddressSelect", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            var _a, _b, _c, _d, _e;
            if (this.props.isEditMode || this.state.isPreviewMode)
                return (null);
            if (((_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType) === null)
                return (null);
            if (!this.props.isAddressSelectionEnabled)
                return (null);
            var addresses = (_c = (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.currentCaseType) === null || _c === void 0 ? void 0 : _c.addresses;
            if (!addresses || addresses.length === 0)
                return (null);
            var items = addresses === null || addresses === void 0 ? void 0 : addresses.map(function (a, index) { return (_jsx(MenuItem, __assign({ value: a.id }, { children: buildAddressString(a) }), index)); });
            var label = (_d = this.props.languageStore) === null || _d === void 0 ? void 0 : _d.getLabel('AddressBook.Address');
            var currentAddressId = (_e = this.props.caseTypesStore) === null || _e === void 0 ? void 0 : _e.currentAddressId;
            if (!currentAddressId)
                currentAddressId = NO_ID;
            return (_jsxs(Grid, __assign({ container: true, alignItems: "center", item: true, sm: 3 }, { children: [_jsx("label", { children: _jsx("b", { children: label }, void 0) }, void 0), _jsx(FormControl, __assign({ style: { flex: 1, marginLeft: '15px', paddingRight: '20px' }, variant: "outlined" }, { children: _jsxs(Select, __assign({ name: "addressSelect", value: currentAddressId, onChange: function (e) { return _this.onAddressValueChanged(e); } }, { children: [_jsx(MenuItem, __assign({ value: NO_ID }, { children: "\u00A0" }), NO_ID), items] }), void 0) }), void 0)] }), void 0));
        }
    });
    Object.defineProperty(CustomFieldsPanel.prototype, "onCaseTypeValueChanged", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a;
            (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.setCurrentCaseType(e.target.value);
        }
    });
    Object.defineProperty(CustomFieldsPanel.prototype, "onAddressValueChanged", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (e) {
            var _a;
            (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.setCurrentAddress(e.target.value);
        }
    });
    Object.defineProperty(CustomFieldsPanel.prototype, "renderAddButton", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            if (!this.props.isEditMode)
                return null;
            return (_jsxs(Button, __assign({ variant: "outlined", onClick: function (e) { return _this.onAddClick(); }, sx: { width: '260px' } }, { children: [_jsx(AddCircleIcon, {}, void 0), _jsx("span", { children: "Add New Field" }, void 0)] }), void 0));
        }
    });
    Object.defineProperty(CustomFieldsPanel.prototype, "renderResetButton", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            if (!this.props.isEditMode)
                return null;
            return (_jsxs(Button, __assign({ variant: "outlined", onClick: function () { return _this.onResetClick(); }, sx: { width: '260px' } }, { children: [_jsx(RotateLeftIcon, {}, void 0), _jsx("span", { children: "Reset" }, void 0)] }), void 0));
        }
    });
    Object.defineProperty(CustomFieldsPanel.prototype, "renderPreviewButton", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _this = this;
            if (!this.props.isEditMode)
                return null;
            return (_jsxs(Button, __assign({ variant: "outlined", onClick: function () { return _this.onPreviewClick(); }, sx: { width: '260px' } }, { children: [this.state.isPreviewMode ? _jsx(ListIcon, {}, void 0) : _jsx(VisibilityIcon, {}, void 0), _jsx("span", { children: this.state.isPreviewMode ? 'Edit' : 'Preview' }, void 0)] }), void 0));
        }
    });
    Object.defineProperty(CustomFieldsPanel.prototype, "onResetClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a, _b;
            var caseType = (_a = this.props.caseTypesStore) === null || _a === void 0 ? void 0 : _a.currentCaseType;
            if (!caseType)
                return;
            // eslint-disable-next-line no-restricted-globals
            if (!confirm('Do you wish to reset fields to default?'))
                return;
            var updatedCaseType = __assign(__assign({}, caseType), { fields: '' });
            (_b = this.props.caseTypesStore) === null || _b === void 0 ? void 0 : _b.updateCaseType(updatedCaseType);
        }
    });
    Object.defineProperty(CustomFieldsPanel.prototype, "onAddClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            var _a;
            (_a = this.props.fieldsStore) === null || _a === void 0 ? void 0 : _a.addField({
                type: CustomFieldType.Text,
                value: '',
                width: 2
            });
        }
    });
    Object.defineProperty(CustomFieldsPanel.prototype, "onPreviewClick", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            this.setState(__assign(__assign({}, this.state), { isPreviewMode: !this.state.isPreviewMode }));
        }
    });
    CustomFieldsPanel = __decorate([
        inject('fieldsStore'),
        inject('languageStore'),
        inject('caseTypesStore'),
        observer
    ], CustomFieldsPanel);
    return CustomFieldsPanel;
}(React.Component));
export default CustomFieldsPanel;
